import { useRef, useState, useEffect, useCallback } from "react";
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
import "ag-grid-community/dist/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/dist/styles/ag-theme-alpine.css"; // Optional theme CSS
import { Button, Box } from "@chakra-ui/react";
// const ROW_DATA = [
//   {
//     profile: "Data Analyst",
//     email_id: "AkhilaCR112@gmail.com",
//     keyword_present: 5,
//     matched_skills: ["Spark", "Hive", "Scala", "Amazon S3 (AWS S3)", "Hadoop"],
//     job_title: ["Data Engineer"],
//     req_id: "PS82424",
//     score_combined: 14.78,
//     rank_combined: 214,
//     score_interpretation: "average",
//   },
//   {
//     profile: "DevOps",
//     email_id: "AkhilaCR112@gmail.com",
//     keyword_present: 5,
//     matched_skills: ["Spark", "Hive", "Scala", "Amazon S3 (AWS S3)", "Hadoop"],
//     job_title: ["Data Engineer"],
//     req_id: "PS82424",
//     score_combined: 14.78,
//     rank_combined: 214,
//     score_interpretation: "average",
//   },
//   {
//     profile: "Big Data",
//     email_id: "AkhilaCR112@gmail.com",
//     keyword_present: 5,
//     matched_skills: ["Spark", "Hive", "Scala", "Amazon S3 (AWS S3)", "Hadoop"],
//     job_title: ["Data Engineer"],
//     req_id: "PS82424",
//     score_combined: 14.78,
//     rank_combined: 214,
//     score_interpretation: "average",
//   },
// ];

const MatchResumeGrid = ({ serializedRowData }) => {
  const gridRef = useRef();
  useEffect(() => {
    setRowData(serializedRowData);
  }, [serializedRowData]);

  const [rowData, setRowData] = useState(serializedRowData);
  const [columnDefs] = useState([
    {
      field: "profile",
      headerName: "Job Profile",
      pinned: "left",
      width: 300,
      resizable: true,
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ["reset", "apply"],
        closeOnApply: true,
      },
    },
    {
      field: "email_id",
      headerName: "Email",
      pinned: "left",
      width: 300,
      resizable: true,
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ["reset", "apply"],
        closeOnApply: true,
      },
    },
    {
      field: "keyword_present",
      headerName: "Keyword Present",
      resizable: true,
      filter: "agNumberColumnFilter",
      filterParams: {
        buttons: ["reset", "apply"],
        closeOnApply: true,
      },
    },
    {
      field: "matched_skills",
      headerName: "Matched Skills",
      resizable: true,
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ["reset", "apply"],
        closeOnApply: true,
      },
    },
    {
      field: "all_resume_skills",
      headerName: "All Resume Skills",
      resizable: true,
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ["reset", "apply"],
        closeOnApply: true,
      },
    },
    {
      field: "job_title",
      headerName: "Carrer Titles",
      resizable: true,
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ["reset", "apply"],
        closeOnApply: true,
      },
    },
    { field: "req_id", headerName: "Requisition ID", resizable: true },
    {
      field: "score_combined",
      headerName: "Score",
      resizable: true,
      filter: "agNumberColumnFilter",
      filterParams: {
        buttons: ["reset", "apply"],
        closeOnApply: true,
      },
    },
  ]);

  useEffect(() => {
    setRowData(serializedRowData);
  }, [serializedRowData]);

  const onDownload = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);

  return (
    <>
      <Box textAlign="end " width="1150px">
        <Button size="sm" onClick={onDownload}>
          Download
        </Button>
      </Box>
      <div className="ag-theme-alpine" style={{ width: 1150, height: 220 }}>
        <AgGridReact
          ref={gridRef} // Ref for accessing Grid's API
          rowData={rowData} // Row Data for Rows
          columnDefs={columnDefs} // Column Defs for Columns
        />
      </div>
    </>
  );
};

export default MatchResumeGrid;
